import { SpanContext, TraceFlags } from '@opentelemetry/api';
import { RandomHexFactory } from './random-hex-factory.model';
import { SPAN_ID_BYTES } from './span-id-bytes.constant';
import { TRACE_ID_BYTES } from './trace-id-bytes.constant';
import { isValidSpanContext } from './is-valid-span-context.function';

export function createSpanContext(randomHex: RandomHexFactory): SpanContext {
  const spanContext: SpanContext = {
    traceId: randomHex(TRACE_ID_BYTES).toLowerCase(),
    spanId: randomHex(SPAN_ID_BYTES).toLowerCase(),
    traceFlags: TraceFlags.SAMPLED,
  };

  if (!isValidSpanContext(spanContext)) {
    throw new Error('Random hex factory produced an invalid span context.');
  }

  return spanContext;
}
